import {
	INavigationItem,
	INavigationLink,
} from '@components/Layouts/Layout/Layout';
import { useLocation } from '@reach/router';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext } from 'react';

import { Button, Card, SVGWrapper } from '../../index';
import { ArrowRight, Chevron } from '../Icon';
import * as styles from './MegaMenu.module.css';

const MegaMenu = ({
	children,
	menu,
	links,
	setOpen,
	open,
	isCampaign,
}: {
	children: React.ReactNode;
	menu: INavigationItem[];
	links: INavigationLink[];
	open: boolean;
	isCampaign?: boolean;
	setOpen: (arg: number) => void;
}) => {
	const location = useLocation();
	const { variant } = useContext(ThemeContext);

	return (
		<>
			<div
				className={cx(styles.overlay, 'site-container', {
					[styles.open]: open,
				})}
				onClick={() => setOpen(-1)}></div>
			<div
				className={cx(styles.menu, styles[variant], {
					[styles.open]: open,
				})}>
				<div className={styles.layout}>
					<div
						className={cx(styles.content, {
							[styles.small]: menu.length > 6,
						})}>
						<div className="rhythm">{children}</div>

						{links && (
							<ul className={styles.links}>
								{links.map(({ to, label }, i) => (
									<li key={'linksLi' + i}>
										<Button
											to={to}
											theme="inline"
											className={styles.link}
											onClick={() => setOpen(-1)}>
											{label}
											{isCampaign ? null : <ArrowRight className={styles.arrow} /> }
										</Button>
									</li>
								))}
							</ul>
						)}
					</div>
					<nav
						className={cx(styles.nav, {
							[styles.tight]: menu.length > 6,
							[styles.delay]: menu.find((e) => e?.subMenu),
						})}>
						<ul
							className={cx(styles.grid, {
								[styles.tall]: menu.length === 2,
								[styles.gutter]: menu.length === 3,
								[styles.box]: menu.length === 4,
								[styles.extend]: menu.length > 6,
								[styles.row]: menu.find((e) => e?.subMenu),
							})}>
							{menu.find((e) => e?.subMenu)
								? menu.map(
										({ to, label, subMenu }, i) =>
											to &&
											(subMenu ? (
												<li
													className={cx(
														styles.item,
														styles.column,
														styles.align
													)}
													key={i}>
													<Link
														to={to}
														className={styles.primary}
														activeClassName={styles.primaryActive}
														partiallyActive={true}
														onClick={() => setOpen(-1)}>
														<SVGWrapper
															height="0.75rem"
															width="0.75rem"
															className={styles.icon}>
															<Chevron />
														</SVGWrapper>
														{label}
													</Link>

													<ul className={styles.list}>
														{subMenu.map(({ to, label }, i) => {
															return (
																<li className={styles.item} key={i}>
																	<Link
																		to={to}
																		className={styles.secondary}
																		partiallyActive={true}>
																		<SVGWrapper
																			height="0.75rem"
																			width="0.75rem"
																			className={styles.icon}>
																			<Chevron />
																		</SVGWrapper>
																		{label}
																	</Link>
																</li>
															);
														})}
													</ul>
												</li>
											) : (
												<li className={cx(styles.item, styles.align)} key={i}>
													<Link
														to={to}
														className={styles.primary}
														activeClassName={styles.primaryActive}
														partiallyActive={true}
														onClick={() => setOpen(-1)}>
														<SVGWrapper
															height="0.75rem"
															width="0.75rem"
															className={styles.icon}>
															<Chevron />
														</SVGWrapper>
														{label}
													</Link>
												</li>
											))
									)
								: menu.map(({ to, label, description }, i) => (
										<li className={styles.item} key={i}>
											<Card
												to={to}
												background="grey"
												theme="plain"
												className={cx({
													[styles.currentCard]: to === location.pathname,
												})}
												onClick={() => setOpen(-1)}>
												<h5 className={styles.heading}>{label}</h5>
												{description && (
													<p className={styles.description}>
														{description.split(' ').length > 14
															? `${description
																	.split(' ')
																	.slice(0, 14)
																	.join(' ')}...`
															: description}
													</p>
												)}
											</Card>
										</li>
									))}
						</ul>
					</nav>
				</div>
			</div>
		</>
	);
};

export default MegaMenu;
